import { render, staticRenderFns } from "./RegionsView.vue?vue&type=template&id=50eba9c1"
import script from "./RegionsView.vue?vue&type=script&lang=js"
export * from "./RegionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports